import { Component, OnInit, TemplateRef } from '@angular/core';
import { Location } from '@angular/common';
import { Router, ActivatedRoute } from '@angular/router';
import { serviceURLService } from '../service/serviceURL';
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';

import { ToasterService } from '../services/toaster.service';
import { CommonService } from '../services/common.service';
import { PlatformLocation } from '@angular/common';
import { takeUntil } from 'rxjs/internal/operators/takeUntil';
import { Subject } from 'rxjs/internal/Subject';

import * as $ from 'jquery';
import { environment } from '../../environments/environment';

import { SharingDataService } from '../service/sharing-data.service';
import { NotificationService } from '../services/notification.service';
import { DataService } from '../data.service';
declare var $: any;
@Component({
  selector: 'app-nav',
  templateUrl: './nav.component.html',
  styleUrls: ['./nav.component.css'],
  providers: [ToasterService,CommonService]
})
export class NavComponent implements OnInit {
  checkUrl: string;
  appTitle = 'myapp';
  currentDate = new Date();
  name: any;
  email: any;
  authToken: any;
  firstName: any;
  mobile: any;
  message: string;
  error: any;
  navTitle: any;
  navIcon: any;
  locationParam: any = {};
  checkLaunchFlag: boolean;
  userDetails: object = {};
  loading: boolean;
  roleData: any = [];
  partnerId: string;
  isDisplayAttendance:boolean;
  redeemSuccess: boolean = false;
  userId:any;
  redeemAmount: any;
  modalRef: BsModalRef;
  prospectIdDca: string;
  data: {};
  url:string;
  private onDestroy$: Subject<void> = new Subject<void>();
  showPolicies: boolean = false

  referralData: any =  {
    passbook_data : []
  };
  balanceValue: any= 0.00;
  showMFineFGPC: boolean = false;
  freeGpcStatus: any = '';
  showMFineFreeSpecialist: boolean = false;
  isCorporateHealthCheckupRestricted: boolean = false;
  showPsychiatrist: boolean = false;
  showSecurenowFacilities:boolean=true;
  locationErrorMessage: string;
  useId:any;
  isNotificationEnabled = '';
  unreadNotificationcount: number = 0;
  fcmToken: any;
  constructor(private _location: Location, 
    private router: Router, 
    private activatedRoute: ActivatedRoute, 
    private serviceURLService: serviceURLService,
    
    private modalService: BsModalService, 
    public toasterService: ToasterService, 
    public commonService : CommonService, 
    private platformLocation: PlatformLocation,
    private _sharingDataService:SharingDataService,
    private notificationService: NotificationService,
    private dataService: DataService
    
    ) {
    this.name = localStorage.getItem('name');
    this.email = localStorage.getItem('email');
    this.mobile = localStorage.getItem('mobileNumber');
    this.useId=localStorage.getItem('userID');
    this.fcmToken = localStorage.getItem('fcmToken');
    this.isNotificationEnabled = localStorage.getItem('isNotificationEnabled');
    if (this.name) {
      this.firstName = this.name.replace(/ .*/, '');
    }
    this.isDisplayAttendance=JSON.parse(localStorage.getItem('isDisplayAttendance'));
    // this.balanceValue = this.referralData.Balance;
    this.balanceValue = localStorage.getItem('Walletvalue');
    this.showMFineFGPC = JSON.parse(localStorage.getItem('mFineFGPC'));
    this.freeGpcStatus = JSON.parse(localStorage.getItem('isFreeGpcSubscribed'));
    this.showMFineFreeSpecialist = JSON.parse(localStorage.getItem('mFineFreeSpecialist'));
    this.isCorporateHealthCheckupRestricted = JSON.parse(localStorage.getItem('isCorporateHealthCheckupRestricted'));
    this.showPsychiatrist = JSON.parse(localStorage.getItem('isPsychiatristTab'));
    if(this.showMFineFGPC !== true && this.showMFineFGPC !== false){
      this._sharingDataService.attendanceSubject.subscribe(data => {
        this.isDisplayAttendance = data.attendanceStatus
        this.showMFineFGPC = data.mFineFGPC
        this.showMFineFreeSpecialist = data.mFineFreeSpecialist
        this.isCorporateHealthCheckupRestricted = data.isCorporateHealthCheckupRestricted
        this.showPsychiatrist = data.isPsychiatristTab
      })
    }else{
      this._sharingDataService.attendanceSubject.subscribe(data => {
        this.isCorporateHealthCheckupRestricted = data.isCorporateHealthCheckupRestricted
        this.showPsychiatrist = data.isPsychiatristTab
      })
    }
  }

  backClicked() {
    this._location.back();
  }

  refresh(): void {
    window.location.reload();
  }

  ngOnInit() {
    this.loading = true
    this.showPolicies =  JSON.parse(localStorage.getItem("showPolicy"))
    if (environment.production) {
      this.partnerId = "997";
    } else {
      this.partnerId = "997";
    }
    this.getShortName(name);
    this.getHeaderTitle();
    this.checkLaunchFlagFunc();
    if(localStorage.getItem('role_pam')){
      this.roleData = JSON.parse(localStorage.getItem('role_pam'));
    }
    this.userId = localStorage.getItem("userID");
    this.showMFineFGPC = JSON.parse(localStorage.getItem('mFineFGPC'));
    this.showMFineFreeSpecialist = JSON.parse(localStorage.getItem('mFineFreeSpecialist'));
    this.isCorporateHealthCheckupRestricted = JSON.parse(localStorage.getItem('isCorporateHealthCheckupRestricted'));
    this.showPsychiatrist = JSON.parse(localStorage.getItem('isPsychiatristTab'));
    this.checkLogOut();
    // this.getAttendanceStatus();
    this.getAuthTokenStatus();
    if((!!localStorage.getItem('pamClientId') && localStorage.getItem('pamClientId').toLowerCase() === "738113".toLowerCase())
      || (!! localStorage.getItem('companyName') && localStorage.getItem('companyName').toLowerCase().trim() === "National Foundation for India-CSOs".toLowerCase().trim())){
      this.showSecurenowFacilities=false
    }

    if(this.isNotificationEnabled === 'true' && !this.fcmToken){
      this.saveFCMToken(this.userId).then(
        res => {
          console.log('FCM Token saved successfully', res);
        },
        err => {
          console.error('Error saving FCM Token', err);
        }
      );
    }

    this.getCountOfNotifications();
    this.dataService.notificationsCount.subscribe(count => {
      this.unreadNotificationcount = count;
    });
  }

  openModal(template: TemplateRef<any>) {
    this.redeemSuccess = false;
    this.modalRef = this.modalService.show(template, { class: 'modal-lg modal-dialog-centered', ignoreBackdropClick: false });
  }

  checkLaunchFlagFunc() {
    var launchFlag = localStorage.getItem("checkLaunchFlag")
    if (launchFlag == "true") {
      this.checkLaunchFlag = true;
    }
  }

  getHeaderTitle() {
    this.navTitle = this.activatedRoute.snapshot.data['headerTitle'];
    console.log(this.navTitle)
    this.navIcon = this.activatedRoute.snapshot.data['headerIcon'];
    this.activatedRoute.queryParamMap.subscribe(params => {
      const service = params.get('service');

      if (service === 'mentalHealth') {
        this.navTitle = 'Mental Health';
      }
    });
  }

  getAuthTokenStatus() {

    var enToken = btoa( btoa(Math.random().toString()).slice(0,8)+ btoa(Math.random().toString()).slice(0,8) +
    btoa(localStorage.getItem('authToken').trim().slice(1).slice(0,-1))+ btoa((Math.random().toString())).slice(0,8) + btoa((Math.random().toString())).slice(0,8) )
 
    var enEmail = btoa( btoa(Math.random().toString()).slice(0,8)+ btoa(Math.random().toString()).slice(0,8) +
    btoa(localStorage.getItem('email').trim())+ btoa((Math.random().toString())).slice(0,8) + btoa((Math.random().toString())).slice(0,8) )

    var enMobile = btoa( btoa(Math.random().toString()).slice(0,8)+ btoa(Math.random().toString()).slice(0,8) +
    btoa(localStorage.getItem('mobileNumber').trim())+ btoa((Math.random().toString())).slice(0,8) + btoa((Math.random().toString())).slice(0,8) )
    
    var enId  = btoa( btoa(Math.random().toString()).slice(0,8)+ btoa(Math.random().toString()).slice(0,8) +
    btoa(localStorage.getItem('userID').trim())+ btoa((Math.random().toString())).slice(0,8) + btoa((Math.random().toString())).slice(0,8) )

    var enName  = btoa( btoa(Math.random().toString()).slice(0,8)+ btoa(Math.random().toString()).slice(0,8) +
    btoa(localStorage.getItem('name').trim().replace(/\s/g, '_'))+ btoa((Math.random().toString())).slice(0,8) + btoa((Math.random().toString())).slice(0,8) )

    var authData={
        $v3s6:enMobile,
        r$_dy:enEmail,
        x4$zl:enId,
        b_epqj:enToken,
        hj_5cy:enName
    }
    this.serviceURLService.verifyAuthTokenstatus(authData).subscribe((successData: any) => {
      const resStatus = atob(atob(successData.response.QZ_ipn).slice(10).slice(0,-10));
      //console.log(" resStatus ",resStatus)
      if(resStatus.toLowerCase()=='false'){
        localStorage.clear();
        this.router.navigate(['login']);
      }      
    }, errorData => {
      // localStorage.clear();
      // this.router.navigate(['login']);
    })
  }

  openNav() {
    document.getElementById("mySidenav").style.width = "300px";
    document.getElementById("sidenav-overlay").style.display = "block";
  }

  closeNav() {
    document.getElementById("mySidenav").style.width = "0";
    document.getElementById("sidenav-overlay").style.display = "none";
  }

  checkLoggedin() {
    this.authToken = localStorage.getItem('authToken');
  
    if (!this.authToken) {
      this.closeNav();
      this.router.navigate(['login']);
      const loginErrorElement = document.getElementById("loginFirstError");
      if (loginErrorElement) {
        loginErrorElement.style.visibility = "visible";
        setTimeout(() => { loginErrorElement.style.visibility = "hidden"; }, 3000);
      }
      return; // Exit early if user is not logged in
    }

    const redirectionURL = window.location.pathname.split('/').pop();
    const allowedPages = ['profile', 'launch-offer'];
    if (allowedPages.includes(redirectionURL)) {
      this.router.navigate([redirectionURL]);
    } else {
      this.router.navigate(['/checkIn']);
    }
  }

  getShortName(fullName) {
    return this.name.split(' ').map(n => n[0]).join('');
  }
  logout() {
    localStorage.clear();
    //this.refresh();
    this.router.navigate(['login']);
  }



  healthAssureUpdate() {
    this.loading = true;
    this.userDetails = {
      UserName: "pujasingh@securenow.in", // hardcode
      FirstName: this.name, //full name
      LastName: "",
      Email: this.email,
      Mobile: this.mobile,
      EmpNo: "", //blank
      DoB: "", //blank
      Gender: "", //blank
      AccessCode: "SN0001", // hardcode
      partnerId: "",
      product: 139,
      company: "",
      designation: "",
      channel: "",
      googleClickID: "",
      leadSource: "Notify-App",
      location: "",
      prospectId: "",
      rmId: ""
    }

    let dataUser = { "userDetails": this.userDetails };


    this.serviceURLService.updateWellnessRegistration(dataUser).subscribe((successData: any) => {
      // console.log("Wellness regitration successfull ",successData)
      this.loading = true;
      var HALink = successData.response.HALink;
      window.location.href = HALink;
    }, errorData => {
      console.log("Oops..!! there is some error in prospect creation");
      if (errorData.error.status === 403) {
        this.error = errorData.error.message;
      }
    })
  }
  //create motor prospect and redirect to Pam
  createProspectForMotor() {
    let data = {
      mobile: this.mobile,
      prospectId: "",
      rmId: "",
      product: 23,
      email: this.email,
      name: this.name,
      company: "",
      location: "",
      designation: "",
      comment: "",
      partnerId: this.partnerId,
      channel: "Notify-App",
      leadSource: "Notify-App",
      googleClickID: "",
      couponCode: ""
    }
      this.serviceURLService.createProspect(data).subscribe((successData: any) => {
        let prospectIdMotor = successData.data.prospectId;
        window.open(environment.pam2Url + '/individual-insurance/motor-car-insurance-policy/details?prospect='
      + prospectIdMotor);
      }, errorData => {
        if (errorData.error.status === 403) {
          this.error = errorData.error.message;
        }
      })
    //}
  }


  getWalletHisotry() {
    this.loading = true;
    this.serviceURLService.getWalletHistory(this.userId).subscribe((success: any) => {
      this.referralData = success.response;
      localStorage.setItem("Walletvalue", this.referralData.Balance);
      this.balanceValue = localStorage.getItem('Walletvalue');
      console.log("balance value " + this.balanceValue);
      this.redeemAmount = this.convertRedeemAmount(this.referralData.Balance);
      this.loading = false;
    },error => {
      this.loading = false;
    })
  }

  redeemWalletPoints() {
    this.loading = true;
    let data = {
      "amount": this.redeemAmount
    }
    this.serviceURLService.redeemWalletPoints(this.userId, data).subscribe((success: any) => {
      this.referralData.Balance = success.response.Balance;
      this.getWalletHisotry();
      this.redeemSuccess = true;
      this.loading = false;
    },error => {
      this.loading = false;
    })
    
  }

   // convert the value for redeem with 500 gap
   convertRedeemAmount (value) {
    var returnvalue = value/500;
    return Math.floor(returnvalue)*500;
  }

  checkLogOut() {
    var logOut = localStorage.getItem("logOut")
    if (logOut != "2") {
      // localStorage.clear();
      // this.router.navigate(['login']);
    }
  }

  createProspectForTermLife() {
    window.open('https://www.maxlifeinsurance.com/term-insurance-plans/get-quote?utmCode=143727634&utm_source=CorporateJourney&utm_medium=GroupBroker&utm_campaign=Secure%20Now%20Broker&utm_content=143727634', '_blank');
  }

  createProspectForHospitalCash() {
    this.loading = true;
    this.prospectIdDca = localStorage.getItem('prospectIdDca');
    this.data = {
      mobile: this.mobile,
      prospectId: this.prospectIdDca?this.prospectIdDca:"",
      quoteId: "",
      rmId: "",
      product: 150,
      email: this.email,
      name: this.name,
      company: "",
      location: "",
      designation: "",
      comment: "",
      partnerId: this.partnerId,
      channel: "",
      leadSource: "Notify-App",
      googleClickID: "",
      couponCode: ""
    }
    
    this.serviceURLService.createProspectForDCA(this.data).pipe(takeUntil(this.onDestroy$)).subscribe((successData: any) => {
      this.loading = false;
      localStorage.setItem("prospectIdDca", successData.data.prospectId);
      window.open(environment.pam2Url + '/individual-insurance/daily-hospital-cash/quote?redirectionFromApp=true&&prospect='
      + successData.data.prospectId);
      this.router.navigate(['/home'])
      return
    },
      errorData => {
      console.log("Oops..!! there is some error in prospect creation");
      if (errorData.error.status === 403) {
        this.error = errorData.error.message;
      }
    });   
  }

  getVisitTeleConsultation(planId: string) {
    this.serviceURLService.corporateHealthCheckUp(this.useId, planId).subscribe((successData: any) => {
      console.log('successData===>', successData)
      const redirectionUrl = successData.response.redirectionUrl;
      // Open the URL in a new tab
      const a = document.createElement('a');
      a.href = redirectionUrl;
      a.target = '_blank';
      a.rel = 'noopener noreferrer';
      a.click();

      setTimeout(() => {
        this.router.navigate(['/home']);
      }, 500);
      // Close the new tab
    }, errorData => {
      console.log('errorData===>', errorData)
      setTimeout(() => {
        this.router.navigate(['/home']);
      }, 500);
    })
  }
  getVisitPsychiatrist(planId: string) {
    this.serviceURLService.corporateHealthCheckUp(this.useId, planId).subscribe((successData: any) => {
      console.log('successData===>', successData)
      const redirectionUrl = successData.response.redirectionUrl;
      // Open the URL in a new tab
      const a = document.createElement('a');
      a.href = redirectionUrl;
      a.target = '_blank';
      a.rel = 'noopener noreferrer';
      a.click();

      setTimeout(() => {
        this.router.navigate(['/home']);
      }, 500);
      // Close the new tab
    }, errorData => {
      console.log('errorData===>', errorData)
      setTimeout(() => {
        this.router.navigate(['/home']);
      }, 500);
    })
  }
   
  redirectToMfineSidebar(){
    this.saveClickEvent("M-Fine-DSC");
    let firstname = localStorage.getItem('name').split(' ')[0]
    let lastname = localStorage.getItem('name').split(' ')[1]
    let email = localStorage.getItem('email')
    let mobileNumber = '91'+localStorage.getItem('mobileNumber')
    let planData = {}
    let data =  {
      "user_type": "patient",
      "target_url" : environment.targetUrl,
      "user_details": {
      "mobile_number": mobileNumber,
      "firstname": firstname,
      "lastname": lastname,
      "email": email
      }
    }
    
    planData = {
      "plan_id": environment.mfinePlanId,
      "mobile_number": mobileNumber
    }
    this.serviceURLService.reditectToMfineApp(data).subscribe((successData: any) => {
      this.url = successData.redirect_url;
       console.log(this.url, "url print here")
       // Open the URL in a new tab
          const a = document.createElement('a');
          a.href = this.url;
          a.target = '_blank';
          a.rel = 'noopener noreferrer';
          a.click();

          setTimeout(() => {
            this.router.navigate(['/home']);
          }, 500);
        // Close the new tab

       console.log("going to call subscribe API")
         this.serviceURLService.mfineSubscribeAPI(planData).subscribe((successData:any)=>{

         }),errorData =>{
          console.log(errorData)
         }
    }), errorData => {
      console.log(errorData)
    } 
  }

  saveClickEvent(clickOn) {
    var clickedData= {
     email: this.email,
     name: this.name,
     mobile: this.mobile,
     id:this.userId,
     type: clickOn
     }
   this.serviceURLService.saveClicked(clickedData).subscribe((successData: any) => {
    console.log("clicked data saved",clickOn);
   }, errorData => {
    console.log("clicked datanot saved",clickOn);
    })
 }

  redirectToFreeGeneralConsultaion(planId: string) {
    this.saveClickEvent("GetVisit-FGPC")
    this.serviceURLService.corporateHealthCheckUp(this.useId, planId).subscribe((successData: any) => {
      console.log('successData===>', successData)
      const redirectionUrl = successData.response.redirectionUrl;
      // Open the URL in a new tab
      const a = document.createElement('a');
      a.href = redirectionUrl;
      a.target = '_blank';
      a.rel = 'noopener noreferrer';
      a.click();

      setTimeout(() => {
        this.router.navigate(['/home']);
      }, 500);
      // Close the new tab
    }, errorData => {
      console.log('errorData===>', errorData)
      setTimeout(() => {
        this.router.navigate(['/home']);
      }, 500);
    })
  }

  // getAttendanceStatus() { 
  //   //console.log(" isDisplayAttendance ",this.isDisplayAttendance)
  //   this.serviceURLService.getAttendanceTabStatus(localStorage.getItem('userID')).subscribe((success: any) => {
  //     if(success.response.attendanceStatus && success.response.attendanceStatus==true){
  //       localStorage.setItem("isDisplayAttendance", "true");
  //     } else {
  //       localStorage.setItem("isDisplayAttendance", "false");
  //     } 
  //     if(success.response.mFineFGPC && success.response.mFineFGPC==true){
  //       localStorage.setItem("mFineFGPC", "true");
  //       this.showMFineFGPC = true;
  //     } else {
  //       localStorage.setItem("mFineFGPC", "false");
  //       this.showMFineFGPC = false;
  //     }
  //     if(success.response.mFineFreeSpecialist && success.response.mFineFreeSpecialist==true){
  //       localStorage.setItem("mFineFreeSpecialist", "true");
  //       this.showMFineFreeSpecialist = true;
  //     } else {
  //       localStorage.setItem("mFineFreeSpecialist", "false");
  //       this.showMFineFreeSpecialist = false;
  //     }
  //     this.isDisplayAttendance=JSON.parse(localStorage.getItem('isDisplayAttendance'));
  //   //console.log(" isDisplayAttendance ",this.isDisplayAttendance)
  //   },error => {
  //     //console.log(" isDisplayAttendance ", "error")
  //   })
  // }

  getOrUpdateFreeGPCStatus() {
    this.serviceURLService.getAndUpdateFreeGPCStatus(localStorage.getItem('userID'),this.freeGpcStatus).subscribe((success: any) => {
      if(success.response.isFreeGPCSubscribed && success.response.isFreeGPCSubscribed==true){
        localStorage.setItem("isFreeGpcSubscribed", "true");
      } else {
        localStorage.setItem("isFreeGpcSubscribed", "false");
      } 
    },error => {
      console.log(error)
    })
  }

  redirectToMedPay() {
    this.saveClickEvent("Med-Pay");
    let firstname = localStorage.getItem('name').split(' ')[0]
    let middlename = localStorage.getItem('name').split(' ')[1]
    let lastname = localStorage.getItem('name').split(' ')[2]

    if (!middlename && !lastname)
      lastname = 'user'
    else if (middlename && !lastname)
      lastname = middlename
    else if (middlename && lastname)
      lastname = lastname
    
    let mobileNumber = localStorage.getItem('mobileNumber')
    const requestBody = {
      "partner_id": "securenow",
      "user_details": {
        "mobile_number": mobileNumber,
        "firstname": firstname,
        "lastname": lastname
      }
    }
    var windowReference = window.open();
    this.serviceURLService.getMedPayToken().subscribe((successData: any) => {
      const accessToken = successData.access_token
      this.serviceURLService.loginAndredirectToMeday(requestBody, accessToken).subscribe((data: any) => {
        windowReference.location.href = data.response.redirect_url;
      })
    }, error => {
      console.log(error);
    })
  };

  checKClaimsFAQ(){
    var windowReference = window.open();
    windowReference.location.href = 'https://securein.freshdesk.com/support/home';
  }

  corporateHealthCheckup(planId: string) {
    this.serviceURLService.corporateHealthCheckUp(this.useId, planId).subscribe((successData: any) => {
      console.log('successData===>', successData)
      const redirectionUrl = successData.response.redirectionUrl;
      // Open the URL in a new tab
      const a = document.createElement('a');
      a.href = redirectionUrl;
      a.target = '_blank';
      a.rel = 'noopener noreferrer';
      a.click();

      setTimeout(() => {
        this.router.navigate(['/home']);
      }, 500);
      // Close the new tab
    }, errorData => {
      console.log('errorData===>', errorData)
      setTimeout(() => {
        this.router.navigate(['/home']);
      }, 500);
    })
  }

  toggleNotification(event: Event) {
  const checked = (event.target as HTMLInputElement).checked;

  this.isNotificationEnabled = checked ? 'true' : 'false';
  localStorage.setItem('isNotificationEnabled', this.isNotificationEnabled);

  if (checked) {
    this.saveFCMToken(this.userId).then(
        res => {
          console.log('FCM Token saved successfully', res);
        },
        err => {
          console.error('Error saving FCM Token', err);
        }
      );
  } else {
     this.deleteFCMToken(this.userId).then(
        res => {
          console.log('FCM Token deleted successfully', res);
          localStorage.removeItem('fcmToken');
        },
        err => {
          console.error('Error deleting FCM Token', err);
        }
     );
  }
}

  async saveFCMToken(userId: string): Promise<{ success: boolean; token?: string; error?: string }> {
    return await this.notificationService.enableForUser(userId);
  }

  async deleteFCMToken(userId: string): Promise<{ success: boolean; error?: string }> {
    return await this.notificationService.disableForUser(userId);
  }

  getCountOfNotifications(): void {
    this.serviceURLService.getCountOfNotifications(this.userId).subscribe(
      {
        next: (response: any) => {
          this.unreadNotificationcount = response?.unreadCount?.unreadCount || 0;
        },

        error: (error) => {
          console.error('Error fetching count of notifications:', error);
        }
      }
    );
  }
}

